import { render, staticRenderFns } from "./expressDetail.vue?vue&type=template&id=428d8554&scoped=true"
import script from "./expressDetail.vue?vue&type=script&lang=js"
export * from "./expressDetail.vue?vue&type=script&lang=js"
import style0 from "./expressDetail.vue?vue&type=style&index=0&id=428d8554&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428d8554",
  null
  
)

export default component.exports